import React from 'react';
import './adresscard.scss';
import Parser from 'html-react-parser';


export const adressCard = ({ items }) => {
  return (
    <div className='adress-card'>
      {Parser(items.title)}
      <ul>
        <li>{Parser(items.adress)}</li>
        <li>{Parser(items.tel)}</li>
        <li>{Parser(items.fax)}</li>
        <li>{Parser(items.mail)}</li>
      </ul>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/client/components/adresslist/adresscard/adresscard.jsx